import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { APP_VERSION } from "@/lib/appVersion";
import { forzarHoraChile } from "@/lib/fecha";

forzarHoraChile();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// La pantalla de arranque del index.html se retira en cuanto React pintó la primera vista
requestAnimationFrame(() => {
  const boot = document.getElementById("aipos-boot");
  if (boot) {
    boot.style.transition = "opacity .25s ease";
    boot.style.opacity = "0";
    setTimeout(() => boot.remove(), 300);
  }
});

// La pantalla de inicio vive en el .bat del acceso directo (ventana nativa de Windows):
// la web carga como cualquier sitio. Aquí solo se guarda la versión para soporte remoto.
try { localStorage.setItem("aipos_version", APP_VERSION); } catch (_) { /* modo privado */ }

// Service worker: cachea el shell para que el POS abra aunque el equipo arranque sin Internet.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => { /* no bloquea la app */ });
  });
}
